var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedalSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3547_48)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.192187 1.79063C0.065625 1.60313 0 1.37813 0 1.15313C0 0.515625 0.515625 0 1.15313 0H6.27656C6.80156 0 7.29375 0.276562 7.56094 0.726562L10.7719 6.075C8.5125 6.36094 6.49219 7.41563 4.9875 8.97656L0.192187 1.79063ZM23.8031 1.79063L19.0125 8.97656C17.5078 7.41563 15.4875 6.36094 13.2281 6.075L16.4391 0.726562C16.7109 0.276562 17.1984 0 17.7234 0H22.8469C23.4844 0 24 0.515625 24 1.15313C24 1.37813 23.9344 1.60313 23.8078 1.79063H23.8031ZM3.75 15.75C3.75 13.562 4.61919 11.4635 6.16637 9.91637C7.71354 8.36919 9.81196 7.5 12 7.5C14.188 7.5 16.2865 8.36919 17.8336 9.91637C19.3808 11.4635 20.25 13.562 20.25 15.75C20.25 17.938 19.3808 20.0365 17.8336 21.5836C16.2865 23.1308 14.188 24 12 24C9.81196 24 7.71354 23.1308 6.16637 21.5836C4.61919 20.0365 3.75 17.938 3.75 15.75ZM12.3937 11.3016C12.2344 10.9734 11.7703 10.9734 11.6063 11.3016L10.5562 13.4297C10.4906 13.5609 10.3687 13.65 10.2281 13.6688L7.875 14.0109C7.51406 14.0625 7.37344 14.5031 7.63125 14.7609L9.33281 16.4203C9.43594 16.5234 9.48281 16.6641 9.45938 16.8094L9.05625 19.1484C8.99531 19.5047 9.37031 19.7812 9.69375 19.6125L11.7938 18.5062C11.9203 18.4406 12.075 18.4406 12.2016 18.5062L14.3016 19.6125C14.625 19.7812 15 19.5094 14.9391 19.1484L14.5359 16.8094C14.5125 16.6688 14.5594 16.5234 14.6625 16.4203L16.3641 14.7609C16.6266 14.5078 16.4812 14.0672 16.1203 14.0109L13.7719 13.6688C13.6312 13.65 13.5047 13.5562 13.4437 13.4297L12.3937 11.3016Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3547_48"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedalSolid);
export default __webpack_public_path__ + "static/media/medal-solid.3931b0f2b07511d931bff3bdf962626a.svg";
export { ForwardRef as ReactComponent };